import { useTranslation } from 'react-i18next'
import { useGenerationFormStore } from '../store'
import { NumberInput } from '@/shared/components'

const PRESETS = [
  { label: '512x512', width: 512, height: 512 },
  { label: '512x768', width: 512, height: 768 },
  { label: '768x512', width: 768, height: 512 },
  { label: '768x768', width: 768, height: 768 },
  { label: '1024x1024', width: 1024, height: 1024 },
  { label: '768x1344', width: 768, height: 1344 },
  { label: '1344x768', width: 1344, height: 768 },
] as const

export function DimensionsInput() {
  const { t } = useTranslation()
  const width = useGenerationFormStore((s) => s.width)
  const height = useGenerationFormStore((s) => s.height)
  const setWidth = useGenerationFormStore((s) => s.setWidth)
  const setHeight = useGenerationFormStore((s) => s.setHeight)
  const isGenerating = useGenerationFormStore((s) => s.isGenerating)

  const handlePreset = (preset: typeof PRESETS[number]) => {
    setWidth(preset.width)
    setHeight(preset.height)
  }

  return (
    <div className="flex flex-col gap-2">
      <label className="text-xs font-medium text-tg-hint">
        {t('generate.dimensions')}
      </label>

      <div className="flex flex-wrap gap-1.5">
        {PRESETS.map((preset) => {
          const isActive = width === preset.width && height === preset.height
          return (
            <button
              key={preset.label}
              type="button"
              onClick={() => { handlePreset(preset) }}
              disabled={isGenerating}
              className="rounded-md px-2 py-1 text-xs font-medium transition-all duration-150 disabled:opacity-50 active:scale-[0.97]"
              style={{
                backgroundColor: isActive
                  ? 'var(--tg-theme-button-color)'
                  : 'var(--tg-theme-secondary-bg-color)',
                color: isActive
                  ? 'var(--tg-theme-button-text-color)'
                  : 'var(--tg-theme-text-color)',
              }}
            >
              {preset.label}
            </button>
          )
        })}
      </div>

      <div className="grid grid-cols-2 gap-3">
        <NumberInput
          id="width-input"
          label={t('generate.width')}
          value={width}
          onChange={setWidth}
          min={64}
          max={2048}
          step={8}
          disabled={isGenerating}
        />
        <NumberInput
          id="height-input"
          label={t('generate.height')}
          value={height}
          onChange={setHeight}
          min={64}
          max={2048}
          step={8}
          disabled={isGenerating}
        />
      </div>
    </div>
  )
}
